export default "<ion-content class=\"full\">\r\n  <div class=\"splash\">\r\n <img src=\"assets/icon/final.gif\">\r\n</div>\r\n</ion-content>";